import React from 'react';

import { IconButton, Icons } from 'widget/components';
import { useContentContext } from 'widget/content/content-context';
import { useIsPrimaryDark } from 'widget/hooks';

const Closer = () => {
  const { setIsChatActive } = useContentContext();
  const isPrimaryDark = useIsPrimaryDark();

  return (
    <IconButton onClick={() => setIsChatActive(false)} size={24}>
      <Icons.CloseCross fill={isPrimaryDark ? 'white' : 'dark'} size={20} />
    </IconButton>
  );
};

export default Closer;
